<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h4 style="color: white;">Nuevo reportante CHV</h4>
    </div>
    <div class="card-body">
      <form>
        <div class="container" >
          <div class="row"><!--Busca fuente-->
            <div class="col" style="text-align: right;">
              <a>Ingrese el NIT o nombre de  la fuente:</a>
            </div>
            <div class="col">
              <input class="form-control" name="nitfuente" [(ngModel)]="buscarFuente">
            </div>
            <div class="col">
              <button class="btn btn-primary" (click)="BuscarFuente(buscarFuente)">Buscar</button>
            </div>
          </div>
          <br>
          <div class="container" *ngIf="infoFuente">
          <table>
            <tr>
              <td class="col-1"><label>Razón Social:</label></td>
              <td class="col-auto"><input class="form-control" name="RazonSocial" [(ngModel)]="NombreEntidad" disabled></td>
              <td class="col-1"><label>NIT:</label></td>
              <td class="col-2"><input class="form-control" name="nit" [(ngModel)]="Nit" disabled></td>
              <td class="col-1"><label>Código entidad:</label></td>
              <td class="col-2"><input class="form-control" name="codigoentidad" [(ngModel)]="codigoEntidad" disabled></td>
            </tr>
          </table>
          <br>
          <table>
            <tr>
              <td class="col-1"><label>Dirección:</label></td>
              <td class="col-auto"><input class="form-control" name="direccion" [(ngModel)]="Direccion" disabled></td>
              <td class="col-1"><label>Nombre comercial:</label></td>
              <td class="col-auto"><input class="form-control" name="nombrecomercial" [(ngModel)]="NombreComercial" disabled></td>
            </tr>
          </table>
          <br>
          <table>
            <tr>
              <td class="col-1"><label>Departamento:</label></td>
              <td class="col-auto"><input class="form-control" name="depto" [(ngModel)]="Departamento" disabled></td>
              <td class="col-1"><label>Municipio:</label></td>
              <td class="col-auto"><input class="form-control" name="muni" [(ngModel)]="Municipio" disabled></td>
              <td class="col-1"><label>Teléfono:</label></td>
              <td class="col-auto"><input class="form-control" name="telefono" [(ngModel)]="Telefono" disabled></td>
            </tr>
          </table>
          </div>
        </div>
          <br>
          <div><b>Responsable del usuario y clave</b></div>
          <br>
        <div class="container">
          <table>
            <tr>
              <td class="col-auto"><label>Tipo documento:</label></td>
              <td class="col-3"><select class="form-select" name="tipoidentifiacion" [formControl]="tipoDocumento"
                disabled (change)="UpdateVariableNuevaFuente()">
                <option value="" selected></option>
                <option value="CC">Cédula de ciudadanía</option>
                <option value="CE">Cédula de extranjería</option>
              </select></td>
              <td class="col-auto"><label>Número de identificación:</label></td>
              <td class="col-2">
                <input type="text" class="form-control" name="numidentificacion" [formControl]="numIdentificacion" disabled (change)="UpdateVariableNuevaFuente()"  oninput="this.value = this.value.replace(/[^0-9]/g, '')">
              </td>
              <td class="col-auto"><label>Nombres:</label></td>
              <td class="col-4">
                <input type="text" class="form-control" name="nombres" [formControl]="nombres" disabled (change)="UpdateVariableNuevaFuente()" oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')">
              </td>
            </tr>
          </table>
          <br>
          <table>
            <tr>
              <td class="col-auto"><label>Correo:</label></td>
              <td class="col-6"><input type="text" class="form-control" name="email1" [formControl]="email1"
                disabled (change)="VerificarCorreo()"></td>
              <td class="col-auto"><label>Confirmar correo:</label></td>
              <td class="col-6"><input type="text" class="form-control" name="email2" [formControl]="email2"
                disabled (change)="VerificarCorreo()"></td>
            </tr>
          </table>
          <br>
          <table>
            <tr>
              <td class="col-1"><label>Teléfono:</label></td>
              <td class="col-auto"><input type="text" class="form-control" name="tel" [formControl]="telefono" disabled (change)="UpdateVariableNuevaFuente()" oninput="this.value = this.value.replace(/[^0-9]/g, '')"></td>
              <td class="col-1"><label>Extensión:</label></td>
              <td class="col-2"><input type="text" class="form-control" name="ext" [formControl]="extencion" disabled (change)="UpdateVariableNuevaFuente()"></td>
              <td class="col-1"><label>Cargo:</label></td>
              <td class="col-3"><input type="text" class="form-control" name="cargo" [formControl]="cargo" disabled (change)="UpdateVariableNuevaFuente()"></td>
            </tr>
          </table>
        </div>
      </form>
    </div>
    <div class="card-footer">
      <button type="button" class="btn btn-secondary" (click)="regresar()">Cancelar</button>
      <button *ngIf="BTNguardar()" type="button" class="btn btn-secondary" (click)="VerificarCampos()">Guardar</button>
      <button *ngIf="!BTNguardar()" type="button" class="btn btn-primary" (click)="guardar()" [disabled]="btnguardar"
      >Guardar</button>
    </div>
  </div>
</body>

<!--Modal Cargando-->
<button class="btn btn-primary btn-sm" #openmodalcargando data-toggle="modal"  data-target="#modal-cargando" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-md" id="modal-cargando" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <div class="card-body container-fluid">
          <br>
          <div class="row">
            <div class="col-auto" style="margin: auto;">
              <h5>Cargando y verificando información, espere un momento...</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closemodacargando style="visibility: hidden;">
                <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
              </button>
            </div>
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-danger" role="status" style="width: 60px; height: 60px;">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>
